var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M454.71,190.21h-85.6S377.6,167,390.66,167s17.15,16,17.15,16,8.81-8.69,16.05-8.69,13.54,11.49,13.54,11.49S447.63,179.65,454.71,190.21Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.11,99.42h-40s8.94-13,16-13,9.12,8.64,9.12,8.64,5-4,9.58-3.31S389.11,99.42,389.11,99.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.21,158.46H45.29S56,134.64,67.38,133.15s16.87,17.7,16.87,17.7,7.36-6.78,13.15-6.78S107.66,153,107.66,153,119.24,146.88,123.21,158.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.93,69.47H127.29s9-17.26,18.85-17.52,15,13.07,15,13.07S176.37,52.77,179.93,69.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61,188.66H118.08s6.11-11.65,12.73-11.81,10.1,8.81,10.1,8.81S151.21,177.4,153.61,188.66Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.05,
    y: 207.76,
    width: 43.33,
    height: 227.14,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 215.14,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 215.14,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 229.86,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 229.86,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 244.59,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 244.59,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 259.31,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 259.31,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 274.04,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 274.04,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 288.76,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 288.76,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 303.49,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 303.49,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 318.21,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 318.21,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 332.94,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 332.94,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 347.66,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 347.66,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 362.39,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 362.39,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 377.11,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 377.11,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 391.84,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 391.84,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.78,
    y: 406.56,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 406.56,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 821.79) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 391.84,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 792.34) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 377.11,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 762.89) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 362.39,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 733.44) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 347.66,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 703.99) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 332.94,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 674.54) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 318.21,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 645.09) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 303.49,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 615.64) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 288.76,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 586.19) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 274.04,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 556.74) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 259.31,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 527.29) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 244.59,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 497.84) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 229.86,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 468.39) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.23,
    y: 215.14,
    width: 8.42,
    height: 8.67,
    transform: "translate(698.89 438.94) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.55,
    y: 406.56,
    width: 8.42,
    height: 8.67,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.38,
    y: 207.76,
    width: 34.16,
    height: 227.14,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 406.56,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 821.79) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 406.56,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 821.79) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 391.84,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 792.34) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 391.84,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 792.34) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 377.11,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 762.89) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 377.11,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 762.89) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 362.39,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 733.44) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 362.39,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 733.44) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 347.66,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 703.99) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 347.66,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 703.99) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 332.94,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 674.54) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 332.94,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 674.54) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 318.21,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 645.09) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 318.21,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 645.09) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 303.49,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 615.64) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 303.49,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 615.64) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 288.76,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 586.19) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 288.76,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 586.19) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 274.04,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 556.74) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 274.04,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 556.74) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 259.31,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 527.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 259.31,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 527.29) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 244.59,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 497.84) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 244.59,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 497.84) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 229.86,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 468.39) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 229.86,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 468.39) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.07,
    y: 215.14,
    width: 6.96,
    height: 8.67,
    transform: "translate(775.09 438.94) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 215.14,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 229.86,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 244.59,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 259.31,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 274.04,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 288.76,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 303.49,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 318.21,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 332.94,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 347.66,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 362.39,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 377.11,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 391.84,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.35,
    y: 406.56,
    width: 6.96,
    height: 8.67,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.17,
    y: 215.14,
    width: 6.96,
    height: 8.67,
    transform: "translate(757.29 438.94) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.18,
    y: 202.8,
    width: 45.2,
    height: 232.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.09,
    y: 198.18,
    width: 46.29,
    height: 4.62,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.26,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.38,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.49,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 123.6,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.38,
    y: 202.8,
    width: 29.02,
    height: 232.1,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.38,
    y: 198.18,
    width: 30.28,
    height: 4.62,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 209.61,
    width: 4.58,
    height: 225.29,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 215.45,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 230.28,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 245.11,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 259.94,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 274.77,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 289.59,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 304.42,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 319.25,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 334.08,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 348.91,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 363.73,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 378.56,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 393.39,
    width: 4.58,
    height: 9.12,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.47,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.58,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.69,
    y: 408.22,
    width: 4.58,
    height: 26.69,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.72,
    y: 272.32,
    width: 42.87,
    height: 162.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.81,
    y: 261.53,
    width: 36.77,
    height: 10.78,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 277.94,
    width: 33.47,
    height: 121.54,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 289.54,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 301.44,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 313.34,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 325.23,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 337.13,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 349.03,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 360.92,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 372.82,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 384.72,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.42,
    y: 396.62,
    width: 33.47,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.59,
    y: 272.32,
    width: 26.85,
    height: 162.59,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 87.59,
    y: 261.53,
    width: 22.82,
    height: 10.78,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 277.94,
    width: 20.65,
    height: 121.54,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 289.54,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 301.44,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 313.34,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 325.23,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 337.13,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 349.03,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 360.92,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 372.82,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 384.72,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.29,
    y: 396.62,
    width: 20.65,
    height: 2.87,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.04,
    y: 275.06,
    width: 22.9,
    height: 27.05,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 419.94,
    y: 275.06,
    width: 14.52,
    height: 28.04,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 421.01,
    y: 287,
    width: 14.41,
    height: 16.1,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.42,
    y: 287,
    width: 8.99,
    height: 16.1,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.26,
    y: 300.35,
    width: 37.02,
    height: 134.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 306.13,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 306.13,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 314.21,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 314.21,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 322.28,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 322.28,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 330.36,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 330.36,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 338.44,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 338.44,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 346.51,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 346.51,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 354.59,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 354.59,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 362.67,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 362.67,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 370.74,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 370.74,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 378.82,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 378.82,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 386.9,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 386.9,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 394.97,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 394.97,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 403.05,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 403.05,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.49,
    y: 411.12,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 407.38,
    y: 411.12,
    width: 11.64,
    height: 4.76,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.28,
    y: 300.35,
    width: 30,
    height: 134.56,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 411.12,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 827.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 411.12,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 827.01) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 403.05,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 810.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 403.05,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 810.85) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 394.97,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 794.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 394.97,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 794.7) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 386.9,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 778.55) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 386.9,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 778.55) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 378.82,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 762.39) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 378.82,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 762.39) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 370.74,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 746.24) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 370.74,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 746.24) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 362.67,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 730.09) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 362.67,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 730.09) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 354.59,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 713.94) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 354.59,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 713.94) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 346.51,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 697.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 346.51,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 697.78) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 338.44,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 681.63) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 338.44,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 681.63) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 330.36,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 665.48) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 330.36,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 665.48) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 322.28,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 649.32) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 322.28,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 649.32) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 314.21,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 633.17) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 314.21,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 633.17) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.72,
    y: 306.13,
    width: 9.56,
    height: 4.76,
    transform: "translate(894.99 617.02) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.49,
    y: 306.13,
    width: 9.56,
    height: 4.76,
    transform: "translate(870.54 617.02) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.88,
    y: 347.22,
    width: 43.67,
    height: 87.68,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 354.81,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 366.29,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 377.76,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 389.23,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 400.71,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 412.18,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 423.65,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 354.81,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 366.29,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 377.76,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 389.23,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 400.71,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 412.18,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.87,
    y: 423.65,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 354.81,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 366.29,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 377.76,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 389.23,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 400.71,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 412.18,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.96,
    y: 423.65,
    width: 7.73,
    height: 5.37,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.48,
    y: 338.09,
    width: 29.07,
    height: 9.14,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.12,
    y: 332.43,
    width: 18.43,
    height: 5.66,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.55,
    y: 347.22,
    width: 30.64,
    height: 87.68,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.76,
    y: 422.8,
    width: 6.29,
    height: 5.37,
    transform: "translate(631.82 850.97) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.76,
    y: 411.32,
    width: 6.29,
    height: 5.37,
    transform: "translate(631.82 828.02) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.76,
    y: 399.85,
    width: 6.29,
    height: 5.37,
    transform: "translate(631.82 805.07) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.76,
    y: 388.38,
    width: 6.29,
    height: 5.37,
    transform: "translate(631.82 782.13) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.76,
    y: 376.9,
    width: 6.29,
    height: 5.37,
    transform: "translate(631.82 759.18) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.76,
    y: 365.43,
    width: 6.29,
    height: 5.37,
    transform: "translate(631.82 736.23) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.76,
    y: 353.96,
    width: 6.29,
    height: 5.37,
    transform: "translate(631.82 713.28) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 422.8,
    width: 6.29,
    height: 5.37,
    transform: "translate(613.72 850.97) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 411.32,
    width: 6.29,
    height: 5.37,
    transform: "translate(613.72 828.02) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 399.85,
    width: 6.29,
    height: 5.37,
    transform: "translate(613.72 805.07) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 388.38,
    width: 6.29,
    height: 5.37,
    transform: "translate(613.72 782.13) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 376.9,
    width: 6.29,
    height: 5.37,
    transform: "translate(613.72 759.18) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 365.43,
    width: 6.29,
    height: 5.37,
    transform: "translate(613.72 736.23) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.71,
    y: 353.96,
    width: 6.29,
    height: 5.37,
    transform: "translate(613.72 713.28) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 422.8,
    width: 6.29,
    height: 5.37,
    transform: "translate(595.67 850.97) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 411.32,
    width: 6.29,
    height: 5.37,
    transform: "translate(595.67 828.02) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 399.85,
    width: 6.29,
    height: 5.37,
    transform: "translate(595.67 805.07) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 388.38,
    width: 6.29,
    height: 5.37,
    transform: "translate(595.67 782.13) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 376.9,
    width: 6.29,
    height: 5.37,
    transform: "translate(595.67 759.18) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 365.43,
    width: 6.29,
    height: 5.37,
    transform: "translate(595.67 736.23) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.69,
    y: 353.96,
    width: 6.29,
    height: 5.37,
    transform: "translate(595.67 713.28) rotate(180)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.55,
    y: 338.09,
    width: 26,
    height: 9.14,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.55,
    y: 332.43,
    width: 14.09,
    height: 5.66,
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.71,
    y: 225,
    width: 66,
    height: 202.64,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.08,
    y: 204.61,
    width: 49.38,
    height: 20.38,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.19,
    y: 207.76,
    width: 4.22,
    height: 14.09,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.57,
    y: 207.76,
    width: 4.22,
    height: 14.09,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.96,
    y: 207.76,
    width: 4.22,
    height: 14.09,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.35,
    y: 207.76,
    width: 4.22,
    height: 14.09,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.74,
    y: 207.76,
    width: 4.22,
    height: 14.09,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.13,
    y: 207.76,
    width: 4.22,
    height: 14.09,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.46,
    y: 204.61,
    width: 22.46,
    height: 20.38,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 409.61,
    y: 207.76,
    width: 3.59,
    height: 14.09,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.89,
    y: 207.76,
    width: 3.59,
    height: 14.09,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.17,
    y: 207.76,
    width: 3.59,
    height: 14.09,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.46,
    y: 225,
    width: 33.59,
    height: 202.64,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.44,
    y: 194.28,
    width: 1.51,
    height: 10.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.58,
    y: 194.28,
    width: 1.51,
    height: 10.33,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.75,
    y: 176.22,
    width: 44.04,
    height: 18.06,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.22,
    y: 238.95,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 238.95,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.22,
    y: 268.35,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 268.35,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.22,
    y: 297.74,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 297.74,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.22,
    y: 327.14,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 327.14,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.22,
    y: 356.53,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 356.53,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.22,
    y: 385.92,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.01,
    y: 385.92,
    width: 12.18,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.63,
    y: 238.95,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.88,
    y: 238.95,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.63,
    y: 268.35,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.88,
    y: 268.35,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.63,
    y: 297.74,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.88,
    y: 297.74,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.63,
    y: 327.14,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.88,
    y: 327.14,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.63,
    y: 356.53,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.88,
    y: 356.53,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.63,
    y: 385.92,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 426.88,
    y: 385.92,
    width: 7,
    height: 18.65,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.52,
    y: 167.67,
    width: 35.3,
    height: 259.96,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.52,
    y: 182.24,
    width: 35.3,
    height: 2.73,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 193,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 212.18,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 231.35,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 250.52,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 269.7,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 288.88,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 308.04,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 327.22,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 346.4,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 365.57,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 384.74,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 403.92,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 193,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 212.18,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 231.35,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 250.52,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 269.7,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 288.88,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 308.04,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 327.22,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 346.4,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 365.57,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 384.74,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.16,
    y: 403.92,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 193,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 212.18,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 231.35,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 250.52,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 269.7,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 288.88,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 308.04,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 327.22,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 346.4,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 365.57,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 384.74,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 403.92,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 193,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 212.18,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 231.35,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 250.52,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 269.7,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 288.88,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 308.04,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 327.22,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 346.4,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 365.57,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 384.74,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.92,
    y: 403.92,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 193,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 212.18,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 231.35,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 250.52,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 269.7,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 288.88,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 308.04,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 327.22,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 346.4,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 365.57,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 384.74,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 403.92,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 193,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 212.18,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 231.35,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 250.52,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 269.7,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 288.88,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 308.04,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 327.22,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 346.4,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 365.57,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 384.74,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.68,
    y: 403.92,
    width: 6.5,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.17,
    y: 167.67,
    width: 60.35,
    height: 259.96,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.17,
    y: 182.24,
    width: 60.35,
    height: 2.73,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.68,
    y: 153.07,
    width: 38.84,
    height: 14.6,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196.52,
    y: 153.07,
    width: 18.25,
    height: 14.6,
    transform: "translate(411.29 320.74) rotate(180)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 193,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 212.18,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 231.35,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 250.52,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 269.7,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 288.88,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 308.04,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 327.22,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 346.4,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 365.57,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 384.74,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 403.92,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 193,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 212.18,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 231.35,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 250.52,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 269.7,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 288.88,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 308.04,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 327.22,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 346.4,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 365.57,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 384.74,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.64,
    y: 403.92,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 193,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 212.18,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 231.35,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 250.52,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 269.7,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 288.88,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 308.04,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 327.22,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 346.4,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 365.57,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 384.74,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 403.92,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 193,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 212.18,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 231.35,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 250.52,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 269.7,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 288.88,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 308.04,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 327.22,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 346.4,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 365.57,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 384.74,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.11,
    y: 403.92,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 193,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 212.18,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 231.35,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 250.52,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 269.7,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 288.88,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 308.04,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 327.22,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 346.4,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 365.57,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 384.74,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 403.92,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 193,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 212.18,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 231.35,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 250.52,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 269.7,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 288.88,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 308.04,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 327.22,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 346.4,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 365.57,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 384.74,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 177.59,
    y: 403.92,
    width: 10.55,
    height: 15.2,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "113.27 427.63 65.43 427.63 65.43 277.56 113.27 246.55 113.27 427.63",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.12 427.63 70.81 427.63 70.81 281.76 107.12 258.23 107.12 427.63",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.12 427.63 70.81 427.63 70.81 281.76 107.12 258.23 107.12 427.63",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 284.28,
    width: 32.15,
    height: 1.16
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 293.76,
    width: 32.15,
    height: 1.16
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 303.24,
    width: 32.15,
    height: 1.16
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 312.72,
    width: 32.15,
    height: 1.16
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 322.2,
    width: 32.15,
    height: 1.16
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 331.68,
    width: 32.15,
    height: 1.16
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 341.16,
    width: 32.15,
    height: 1.16
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 350.64,
    width: 32.15,
    height: 1.16
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 360.12,
    width: 32.15,
    height: 1.16
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 369.6,
    width: 32.15,
    height: 1.16
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 379.08,
    width: 32.15,
    height: 1.16
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 388.56,
    width: 32.15,
    height: 1.16
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 398.04,
    width: 32.15,
    height: 1.16
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 407.52,
    width: 32.15,
    height: 1.16
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 417,
    width: 32.15,
    height: 1.16
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 74.97,
    y: 426.48,
    width: 32.15,
    height: 1.16
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 13.86,
    y: 349.87,
    width: 154.37,
    height: 1.16,
    transform: "translate(-259.4 441.5) rotate(-90)"
  }))), /*#__PURE__*/React.createElement("polygon", {
    points: "107.12 258.23 107.12 263.45 74.97 284.28 74.97 427.63 70.82 427.63 70.82 281.75 107.12 258.23",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.12 258.23 107.12 263.45 74.97 284.28 74.97 427.63 70.82 427.63 70.82 281.75 107.12 258.23",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.27,
    y: 246.55,
    width: 42.15,
    height: 181.08,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.27,
    y: 246.55,
    width: 42.15,
    height: 181.08,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 258.23,
    width: 33.97,
    height: 4.1
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 267.51,
    width: 33.97,
    height: 4.1
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 276.8,
    width: 33.97,
    height: 4.1
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 286.08,
    width: 33.97,
    height: 4.1
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 295.37,
    width: 33.97,
    height: 4.1
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 304.66,
    width: 33.97,
    height: 4.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 313.94,
    width: 33.97,
    height: 4.1
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 323.23,
    width: 33.97,
    height: 4.1
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 332.51,
    width: 33.97,
    height: 4.1
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 341.8,
    width: 33.97,
    height: 4.1
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 351.09,
    width: 33.97,
    height: 4.1
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 360.37,
    width: 33.97,
    height: 4.1
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 369.66,
    width: 33.97,
    height: 4.1
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 378.94,
    width: 33.97,
    height: 4.1
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 388.23,
    width: 33.97,
    height: 4.1
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 397.52,
    width: 33.97,
    height: 4.1
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 406.8,
    width: 33.97,
    height: 4.1
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 117.36,
    y: 416.09,
    width: 33.97,
    height: 4.1
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 291.77,
    y: 235.91,
    width: 37.92,
    height: 191.73,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.77,
    y: 235.91,
    width: 37.92,
    height: 191.73,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.77,
    y: 229.62,
    width: 40.19,
    height: 6.28,
    transform: "translate(623.73 465.53) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.77,
    y: 219.81,
    width: 34.08,
    height: 9.81,
    transform: "translate(617.61 449.44) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.77,
    y: 219.81,
    width: 34.08,
    height: 9.81,
    transform: "translate(617.61 449.44) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.77,
    y: 198.18,
    width: 26.07,
    height: 21.64,
    transform: "translate(609.61 417.99) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.77,
    y: 198.18,
    width: 26.07,
    height: 21.64,
    transform: "translate(609.61 417.99) rotate(180)",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 295.4,
    y: 243.17,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 295.4,
    y: 270.65,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 295.4,
    y: 298.12,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 295.4,
    y: 325.59,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 295.4,
    y: 353.07,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 295.4,
    y: 380.54,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 243.17,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 270.65,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 298.12,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 325.59,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 353.07,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 303.91,
    y: 380.54,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 312.41,
    y: 243.17,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 312.41,
    y: 270.65,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 312.41,
    y: 298.12,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 312.41,
    y: 325.59,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 312.41,
    y: 353.07,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 312.41,
    y: 380.54,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 320.91,
    y: 243.17,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 320.91,
    y: 270.65,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 320.91,
    y: 298.12,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 320.91,
    y: 325.59,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 320.91,
    y: 353.07,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 320.91,
    y: 380.54,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 214.03,
    y: 235.91,
    width: 77.73,
    height: 191.73,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.76,
    y: 219.81,
    width: 74.01,
    height: 9.81,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.08,
    y: 198.18,
    width: 55.69,
    height: 21.64,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.08,
    y: 198.18,
    width: 55.69,
    height: 21.64,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.71,
    y: 229.62,
    width: 80.06,
    height: 6.28,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.71,
    y: 229.62,
    width: 80.06,
    height: 6.28,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 243.17,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 270.65,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 298.12,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 325.59,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 353.07,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 221.47,
    y: 380.54,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 243.17,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 270.65,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 298.12,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 325.59,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 353.07,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 380.54,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 243.17,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 270.65,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 298.12,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 325.59,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 353.07,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 256.35,
    y: 380.54,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 243.17,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 270.65,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 298.12,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 325.59,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 353.07,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 273.78,
    y: 380.54,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 238.91,
    y: 408.63,
    width: 27.99,
    height: 19,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.57,
    y: 318.3,
    width: 37.92,
    height: 109.33,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.57,
    y: 318.3,
    width: 37.92,
    height: 109.33,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.57,
    y: 312.02,
    width: 40.19,
    height: 6.28,
    transform: "translate(779.33 630.33) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.57,
    y: 302.21,
    width: 34.08,
    height: 9.81,
    transform: "translate(773.22 614.23) rotate(180)",
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.57,
    y: 302.21,
    width: 34.08,
    height: 9.81,
    transform: "translate(773.22 614.23) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 373.21,
    y: 325.57,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 373.21,
    y: 353.04,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 373.21,
    y: 380.52,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 381.71,
    y: 325.57,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 381.71,
    y: 353.04,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 381.71,
    y: 380.52,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 390.21,
    y: 325.57,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 390.21,
    y: 353.04,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 390.21,
    y: 380.52,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 398.71,
    y: 325.57,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 398.71,
    y: 353.04,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 398.71,
    y: 380.52,
    width: 5.14,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 291.84,
    y: 318.3,
    width: 77.73,
    height: 109.33,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.56,
    y: 302.21,
    width: 74.01,
    height: 9.81,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.51,
    y: 312.02,
    width: 80.06,
    height: 6.28,
    style: {
      fill: "#FFC727"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.51,
    y: 312.02,
    width: 80.06,
    height: 6.28,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 299.27,
    y: 325.57,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 299.27,
    y: 353.04,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 299.27,
    y: 380.52,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 316.71,
    y: 325.57,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 316.71,
    y: 353.04,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 316.71,
    y: 380.52,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 334.15,
    y: 325.57,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 334.15,
    y: 353.04,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 334.15,
    y: 380.52,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 351.59,
    y: 325.57,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 351.59,
    y: 353.04,
    width: 10.55,
    height: 20.17
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 351.59,
    y: 380.52,
    width: 10.55,
    height: 20.17
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Birds--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.21,163.8a14.23,14.23,0,0,0-1.6-.68,6.5,6.5,0,0,0-1.74-.4,1.37,1.37,0,0,0-.55.06.56.56,0,0,0-.16.07l-.11.08-.19.16a7.6,7.6,0,0,0-.63.64c-.4.44-.75.9-1.1,1.37l.44-.15a13.53,13.53,0,0,0-1.79-.37,7,7,0,0,0-.93-.07,2.77,2.77,0,0,0-.49,0,1.47,1.47,0,0,0-.27.06,1.66,1.66,0,0,0-.27.13,3.21,3.21,0,0,0-.7.67c-.19.24-.36.49-.53.75a11.42,11.42,0,0,0-.83,1.59c.39-.46.76-.92,1.15-1.36.19-.21.39-.43.6-.62a2.76,2.76,0,0,1,.63-.49,1.59,1.59,0,0,1,.69-.07,6.07,6.07,0,0,1,.84.12c.56.1,1.13.24,1.68.38l.27.08.16-.23c.32-.46.67-.91,1-1.35.17-.22.35-.43.53-.62l.14-.13.07-.05,0,0a1,1,0,0,1,.31-.06,8.77,8.77,0,0,1,1.65.16C338.08,163.58,338.64,163.7,339.21,163.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.92,180.82a18.67,18.67,0,0,0-2.16-1.47,10,10,0,0,0-2.45-1.11,2.49,2.49,0,0,0-.81-.07,1.54,1.54,0,0,0-.27.07l-.18.08-.32.17c-.4.24-.76.5-1.12.76-.71.54-1.35,1.11-2,1.7l.68-.09a19,19,0,0,0-2.5-1.07,9.94,9.94,0,0,0-1.35-.37,4.4,4.4,0,0,0-.74-.1,2.88,2.88,0,0,0-.41,0,3.39,3.39,0,0,0-.43.11,4.57,4.57,0,0,0-1.23.79,9.8,9.8,0,0,0-1,.94,16.79,16.79,0,0,0-1.69,2.09c.7-.56,1.38-1.13,2.08-1.65.35-.27.7-.52,1.06-.75a4.43,4.43,0,0,1,1.07-.53,2.48,2.48,0,0,1,1,.1,10.46,10.46,0,0,1,1.19.41c.8.31,1.6.69,2.36,1.06l.38.2.3-.29c.61-.58,1.25-1.15,1.89-1.69a11,11,0,0,1,1-.75,1.58,1.58,0,0,1,.24-.15l.11-.06s0,0,0,0a1.22,1.22,0,0,1,.47,0,12.48,12.48,0,0,1,2.37.71C331.31,180.16,332.11,180.5,332.92,180.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.67,141.45a14.09,14.09,0,0,0-1.47-.94,6.81,6.81,0,0,0-1.66-.68,1.54,1.54,0,0,0-.54,0,.61.61,0,0,0-.18,0l-.12.06-.21.12c-.26.17-.5.35-.73.53-.46.37-.88.77-1.3,1.18l.45-.08a13,13,0,0,0-1.7-.66,6.37,6.37,0,0,0-.91-.22,3.87,3.87,0,0,0-.49-.05l-.27,0a2.46,2.46,0,0,0-.29.09,2.77,2.77,0,0,0-.8.55,7.73,7.73,0,0,0-.64.64,10.61,10.61,0,0,0-1.08,1.44c.45-.39.89-.79,1.35-1.15.23-.18.45-.36.69-.52a3.23,3.23,0,0,1,.7-.38,1.59,1.59,0,0,1,.7.05,5.7,5.7,0,0,1,.8.25c.54.19,1.08.42,1.6.66l.26.11.19-.19c.39-.41.81-.8,1.22-1.17a7.21,7.21,0,0,1,.63-.52l.16-.11.07,0h0a.73.73,0,0,1,.31,0,9.07,9.07,0,0,1,1.6.43C157.58,141,158.12,141.25,158.67,141.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.93,139.14a18.61,18.61,0,0,0-1.61-2,10.26,10.26,0,0,0-2-1.78,2.49,2.49,0,0,0-.75-.31h-.28l-.19,0-.36.07c-.46.11-.88.25-1.3.39-.83.3-1.62.66-2.42,1l.68.11a20.68,20.68,0,0,0-2.08-1.77,11.34,11.34,0,0,0-1.18-.75,5.91,5.91,0,0,0-.67-.31,2.6,2.6,0,0,0-.4-.1,3.25,3.25,0,0,0-.44,0,4.85,4.85,0,0,0-1.41.39c-.43.18-.83.39-1.23.6a17.81,17.81,0,0,0-2.23,1.51c.84-.33,1.65-.68,2.48-1a11.12,11.12,0,0,1,1.24-.39,4.29,4.29,0,0,1,1.17-.2,2.57,2.57,0,0,1,1,.41,11.45,11.45,0,0,1,1,.75c.67.53,1.32,1.12,1.94,1.71l.31.3.37-.19c.75-.38,1.53-.73,2.3-1a9,9,0,0,1,1.15-.43l.27-.08.13,0h0a1.31,1.31,0,0,1,.45.14,12.36,12.36,0,0,1,2,1.39C171.6,138,172.26,138.59,172.93,139.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.27,176.64a17.47,17.47,0,0,0-1.62-2,9.63,9.63,0,0,0-2-1.78,2.07,2.07,0,0,0-.75-.31,1.23,1.23,0,0,0-.28,0l-.19,0a2.09,2.09,0,0,0-.36.07,10.35,10.35,0,0,0-1.3.39c-.83.3-1.62.65-2.42,1l.68.11a19.45,19.45,0,0,0-2.08-1.77,8.77,8.77,0,0,0-1.18-.75,4.57,4.57,0,0,0-.67-.31c-.12,0-.27-.07-.4-.11a3.24,3.24,0,0,0-.44,0,4.85,4.85,0,0,0-1.41.38,12.79,12.79,0,0,0-1.23.61,17.74,17.74,0,0,0-2.23,1.5c.84-.33,1.65-.67,2.48-1,.41-.15.82-.29,1.24-.4a4.25,4.25,0,0,1,1.17-.19,2.42,2.42,0,0,1,1,.41,9.63,9.63,0,0,1,1,.74c.67.53,1.32,1.13,1.94,1.71l.31.3.37-.19c.75-.37,1.53-.72,2.3-1a10.74,10.74,0,0,1,1.15-.43c.09,0,.19-.06.27-.07l.13,0s0,0,0,0a1.31,1.31,0,0,1,.45.14,12.36,12.36,0,0,1,2.05,1.39C351.94,175.54,352.6,176.1,353.27,176.64Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.42,427.63s-.84-3.92-2.52-4.53-2.71,1.16-2.71,1.16-.39-3.75-2.78-4.88-4.17,1.18-4.17,1.18-1.83-4.76-5.1-4.76-4.91,7-4.91,7-1.93-2.07-3.91-.9-2,5.77-2,5.77Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.26,427.63s-.84-3.92-2.52-4.53-2.7,1.16-2.7,1.16-.4-3.75-2.78-4.88-4.17,1.18-4.17,1.18-1.83-4.76-5.1-4.76-4.92,7-4.92,7-1.92-2.07-3.9-.9-2,5.77-2,5.77Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.7,427.63H133.15s1-4.16,2.93-4.46a2.91,2.91,0,0,1,2.88,1.64s-.09-5.81,3.57-6.8,6.72,4.14,6.72,4.14,2.3-2.92,5.42-2.74,3.93,5,3.93,5S161.44,422.76,162.7,427.63Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.16,427.63H46.61s0-2.31,1.56-2.93a2.09,2.09,0,0,1,2.44.59s.62-4.26,3.47-4.26,4.22,3.67,4.22,3.67a2.18,2.18,0,0,1,2.22-.9C62.1,424,62.16,427.63,62.16,427.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.9,427.63H159.35s0-2.31,1.56-2.93a2.09,2.09,0,0,1,2.44.59S164,421,166.83,421,171,424.7,171,424.7a2.18,2.18,0,0,1,2.22-.9C174.84,424,174.9,427.63,174.9,427.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.7,427.63H415.15s0-2.31,1.56-2.93a2.09,2.09,0,0,1,2.44.59s.62-4.26,3.47-4.26,4.22,3.67,4.22,3.67a2.17,2.17,0,0,1,2.22-.9C430.64,424,430.7,427.63,430.7,427.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.39,427.63H427.75s.06-3.81,2.58-4.83a3.44,3.44,0,0,1,4,1s1-7,5.73-7S447,422.8,447,422.8a3.58,3.58,0,0,1,3.66-1.48C453.29,421.66,453.39,427.63,453.39,427.63Z",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41.36,
    y: 427.63,
    width: 417.27,
    height: 7.27,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.62,427.63a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.63A12.34,12.34,0,0,1,70.62,427.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.23,427.63a12.34,12.34,0,0,1,.5,3.64,12,12,0,0,1-.5,3.63,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.85,427.63a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.63A12.34,12.34,0,0,1,135.85,427.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.46,427.63a12.34,12.34,0,0,1,.5,3.64,12,12,0,0,1-.5,3.63,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.08,427.63a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.63A12.34,12.34,0,0,1,201.08,427.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.69,427.63a12.34,12.34,0,0,1,.5,3.64,12,12,0,0,1-.5,3.63,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.31,427.63a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.63A12.34,12.34,0,0,1,266.31,427.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.92,427.63a12.34,12.34,0,0,1,.5,3.64,12,12,0,0,1-.5,3.63,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,427.63a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.63A12.34,12.34,0,0,1,331.54,427.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.15,427.63a12.34,12.34,0,0,1,.5,3.64,12,12,0,0,1-.5,3.63,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.77,427.63a13.73,13.73,0,0,1,0,7.27,12,12,0,0,1-.5-3.63A12.34,12.34,0,0,1,396.77,427.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.38,427.63a12.34,12.34,0,0,1,.5,3.64,12,12,0,0,1-.5,3.63,13.73,13.73,0,0,1,0-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.45 434.9 95.84 434.66 147.23 434.57 250 434.4 352.77 434.57 404.16 434.66 455.55 434.9 404.16 435.15 352.77 435.24 250 435.4 147.23 435.23 95.84 435.15 44.45 434.9",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Sun--inject-7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 272.27,
    cy: 106.52,
    r: 31.37,
    transform: "translate(4.43 223.72) rotate(-45)",
    style: {
      fill: "#FFC727",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 272.27,
    cy: 106.52,
    r: 19.73,
    style: {
      fill: "#FFC727"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.270da6b217f06da7455d028a746b50f3.svg";
export { ForwardRef as ReactComponent };